import React from 'react';
import { MessageCircle, Trash2, Wifi, WifiOff, Shield, LogOut, User } from 'lucide-react';
import ShieldIcon from './ShieldIcon';
import './Header.css';

const Header = ({ isConnected, onClearChat, messageCount, onShowAdmin, isBltzShieldEnabled, onToggleBltzShield, user, onLogout }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <MessageCircle className="header-icon" size={28} />
          <div className="header-title">
            <h1>AI Chatbot</h1>
            <p>Powered by LangChain & OpenAI</p>
          </div>
        </div>
        
        <div className="header-right">
          <div className="user-info">
            <User size={16} />
            <span className="username">{user?.username}</span>
          </div>
          
          <div className={`connection-status ${isConnected ? 'connected' : 'disconnected'}`}>
            {isConnected ? (
              <>
                <Wifi size={16} />
                <span>Connected</span>
              </>
            ) : (
              <>
                <WifiOff size={16} />
                <span>Disconnected</span>
              </>
            )}
          </div>
          
          <button 
            className={`bltz-shield-button ${isBltzShieldEnabled ? 'enabled' : 'disabled'}`}
            onClick={onToggleBltzShield}
            title={isBltzShieldEnabled ? "Turn off Bltz Shield" : "Turn on Bltz Shield"}
          >
            <ShieldIcon className="shield-icon" />
            <span>{isBltzShieldEnabled ? 'Turn off Bltz Shield' : 'Turn on Bltz Shield'}</span>
          </button>
          
          <button 
            className="admin-button"
            onClick={onShowAdmin}
            title="Admin Panel"
          >
            <Shield size={16} />
            <span>Admin</span>
          </button>
          
          {messageCount > 0 && (
            <button 
              className="clear-button"
              onClick={onClearChat}
              title="Clear conversation"
            >
              <Trash2 size={16} />
              <span>Clear</span>
            </button>
          )}
          
          <button 
            className="logout-button"
            onClick={onLogout}
            title="Sign out"
          >
            <LogOut size={16} />
            <span>Sign Out</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;